import React, { useEffect, useMemo, useState } from 'react';
import { Product } from '../../../types/product';
import { GtmComponent, GtmProduct } from '../../../types/go-to-market';
import { LIST_HEADING_STYLES } from './ArchitectureDetailStyles';
import ArchitectureFeatureCard from './ArchitectureFeatureCard';


const ArchitectureFeatureList: React.FC<{
  products: Map<Product['id'], GtmProduct>,
  pinnedProducts: Set<GtmProduct['id']> | null,
  component: GtmComponent['id'] | null,
}> = ({
  products,
  pinnedProducts,
  component,
}) => {
  const visible = pinnedProducts?.size > 0;

  const [displayComponent, setDisplayComponent] = useState<GtmComponent['id'] | null>(null);
  useEffect(() => {
    if (component) {
      setDisplayComponent(component);
    }
  }, [component]);

  const [displayPinned, setDisplayPinned] = useState<Set<GtmProduct['id']>>(new Set());
  useEffect(() => {
    if (pinnedProducts && pinnedProducts.size > 0) {
      setDisplayPinned(pinnedProducts);
    }
  }, [pinnedProducts]);

  const listItems = useMemo(() => {
    return Array.from(products.values());
  }, [products]);

  const handleTransitionEnd = (e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.propertyName === 'opacity' && !visible) {
      setDisplayPinned(new Set());
      setDisplayComponent(null);
    }
  };

  return (
    <div
      className={`grid overflow-hidden transition-[grid-template-rows,opacity] duration-500 ${visible ? 'opacity-100' : 'opacity-0'}`}
      style={{ gridTemplateRows: visible ? '1fr' : '0fr' }}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className="min-h-0 overflow-hidden flex flex-col -mb-4">
        <h3 className={`${LIST_HEADING_STYLES} mb-4 mt-6`}>Core Features</h3>
        {listItems.map((product) => (
          <ArchitectureFeatureCard
            key={product.id}
            index={product.colorIdx}
            product={product?.name ?? ""}
            features={product.features.get(displayComponent) ?? []}
            visible={displayPinned.has(product.id)}
          />
        ))}
      </div>
    </div>
  );
}

export default ArchitectureFeatureList;